export default "__VITE_ASSET__CaRe6dYX__"